import produce from 'immer';
import { RecorderViewActions } from './actions';

const initialState = {
  recorderViewData: { tdata: [], cdata: [] },
  loading: false,
  loaded: false,
  success: false,
  error: false,
  errorMessage: '',
  actionType: '',
};

const RecorderView = (state = initialState, action) => {
  const { type: actionType, payload } = action;
  switch (actionType) {
    case RecorderViewActions.FETCH_RECORDER_VIEW:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.loaded = false;
        draft.success = false;
        draft.error = false;
        draft.errorMessage = '';
        draft.actionType = actionType;
      });
    case RecorderViewActions.FETCH_RECORDER_VIEW_SUCCESS:
      return produce(state, (draft) => {
        draft.recorderViewData = payload.data;
        draft.loading = false;
        draft.loaded = true;
        draft.success = true;
        draft.error = false;
        draft.actionType = actionType;
      });
    case RecorderViewActions.FETCH_RECORDER_VIEW_UPDATE_SUCCESS:
      return produce(state, (draft) => {
        draft.recorderViewData = payload.data;
        draft.success = true;
        draft.error = false;
        draft.actionType = actionType;
      });
    case RecorderViewActions.FETCH_RECORDER_VIEW_ERROR:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loaded = true;
        draft.success = false;
        draft.error = true;
        draft.errorMessage = payload;
        draft.actionType = actionType;
      });
    case RecorderViewActions.FETCH_RECORDER_VIEW_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.loaded = false;
        draft.success = false;
        draft.error = false;
        draft.errorMessage = '';
        draft.actionType = actionType;
      });
    case RecorderViewActions.FETCH_RECORDER_VIEW_DATA_CLEAR:
      return produce(state, (draft) => {
        draft.recorderViewData = { tdata: [], cdata: [] };
      });
    case RecorderViewActions.SET_RECORDER_VIEW_DATA:
      return produce(state, (draft) => {
        draft.recorderViewData = payload.data;
      });
    default:
      return state;
  }
};

export default RecorderView;
